import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from '@directives/click-outside/click-outside.directive';

@NgModule({
	declarations: [ClickOutsideDirective],
	exports: [ClickOutsideDirective]
})
export class SharedDirectivesModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/directives/directives.module.ts